module.exports = __webpack_public_path__ + "img/unnamed.461456e6.webp";